module.exports = __webpack_public_path__ + "img/dark.d0efa020.svg";